export default __webpack_public_path__ + "images/9382b18abdc5b4ae49681b7ad1e3eae5-craft_small.webp";